import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({ name: 'AvailabilityStatus' })
export default class default_1 extends Vue {
    @Prop()
    isSoldOut;
    @Prop({ required: true })
    available;
    @Prop({ required: true })
    threshold;
    t;
    get label() {
        if (this.isSoldOut)
            return this.t.soldOut;
        else if (!this.threshold)
            return '';
        else if (!this.lowAvailability)
            return this.t.available;
        else
            return this.$t('availabilityStatus.nAvailable', { count: this.available });
    }
    get lowAvailability() {
        return this.available < (this.threshold || 0);
    }
}
